import axios from "axios";
import {apiDetails} from "../constants/apiconstants"
import jwt_decode from 'jwt-decode';

import apiConfig from '../Auth/services/apiConfig';

const config = {
    mode: "no-cors",
    headers: {
        
    }
}

const hostname = window && window.location && window.location.hostname;
const environmentConstants = apiConfig.setEnvironmentURLs(hostname);

async function getAuthToken(url, codeVerifier){
    const code = localStorage.getItem("code");
    let AXWAY_API_KEY = null;
    
    const hostname = window && window.location && window.location.hostname;
    if (hostname.includes("localhost") || hostname.includes("dev-")) {
        AXWAY_API_KEY = process.env.REACT_APP_API_KEY_DEV
    }else if(hostname.includes("tst-")){
        AXWAY_API_KEY = process.env.REACT_APP_API_KEY_TST
    }else if(hostname.includes("acc-")){
        AXWAY_API_KEY = process.env.REACT_APP_API_KEY_ACC
    }else{
        AXWAY_API_KEY = process.env.REACT_APP_API_KEY_PROD
    }

    if (code) {
        let authConfig = {};
        authConfig = {
            mode: "no-cors",
            headers:{
            "X-API-KEY" :environmentConstants.apiKey,
                ...(codeVerifier ? { "X-PKCE-CODE-VERIFIER": codeVerifier } : {})
            }
	}
       
        return axios.get(url,authConfig); 
    } else {
        removeAuthData();
    }
}

function isTokenAvailable () {
    let idToken = localStorage.getItem("IdentityToken");
    return idToken;
}

function removeAuthData () {
    console.log("removeAuthData loop");
    localStorage.removeItem("code"); 
    localStorage.removeItem("state");
    localStorage.removeItem("IdentityToken");
    localStorage.removeItem("refreshToken");
}

function setAuthToken (data)  {
    console.log("setAuthToken is success Language Code",data);

    const rawToken = data && (data.IdentityToken || data.identityToken || data.idToken || data.accessToken || data.access_token);
    const normalizedToken = rawToken ? String(rawToken).replace(/^Bearer\s+/i, "").trim() : "";
    const refreshToken = (data && (data.refreshToken || data.refresh_token)) || "";

    if (!normalizedToken) {
        console.warn("setAuthToken called without a valid token payload.");
        return;
    }

    localStorage.removeItem("IdentityToken"); 
    localStorage.removeItem("refreshToken");
    localStorage.setItem("IdentityToken", normalizedToken);
    localStorage.setItem("refreshToken", refreshToken);

    try {
        let decoded_token = jwt_decode(normalizedToken);
        console.log("decoded token in services.js",decoded_token)
        localStorage.setItem("languageCode",decoded_token.language);
        console.log("setAuthToken is success",normalizedToken,decoded_token.language);
    } catch (error) {
        console.warn("Unable to decode IdentityToken while setting auth token.", error);
    }
}

function setApiErrorInfo (show, message) {
    localStorage.setItem("showError", show);
    localStorage.setItem("showMessage", message);
    window.dispatchEvent(new Event("handleAPIError"))
}

async function getDataAPI(url, token) {
    try {
        setApiErrorInfo(false,'')
        config.headers.Authorization = `Bearer ${token}`;
        return await axios.get(apiDetails.HOST_NAME + apiDetails.CONTEXT + url, config);
    } catch (error) {
        let errorResponse = error && error.response && error.response.data;
        if (errorResponse && errorResponse.message) {
            setApiErrorInfo(true,errorResponse.message)
        }
    }
}
async function getData(url) {
    let token = isTokenAvailable();
    if (token) {
        return await getDataAPI(url, token);
    } else {
        return getAuthToken(apiDetails.GENERATE_TOKEN).then(async(result) => {
            console.log("getAuthToken result",result);
            if (result.data && result.data.IdentityToken) {
                setAuthToken(result.data);
                return await getDataAPI(url, result.data.IdentityToken);
            }
        })
    }
}

async function postDataAPI(url, requestBody, token) {
    try {
        setApiErrorInfo(false,'')
        config.headers.Authorization = `Bearer ${token}`;
        return await axios.post(apiDetails.HOST_NAME + apiDetails.CONTEXT + url, requestBody, config); 
    } catch (error) {
        let errorResponse = error && error.response && error.response.data;
        if (errorResponse && errorResponse.message) {
            setApiErrorInfo(true,errorResponse.message)
        }
        
    }
}


async function postData(url, requestBody) {
    let token = isTokenAvailable();
    if (token !== null && token !== "") {
        return await postDataAPI(url, requestBody, token);
    } else {
        return getAuthToken(apiDetails.GENERATE_TOKEN).then(async(result) => {
            if (result.data && result.data.IdentityToken) {
                setAuthToken(result.data);
                return await postDataAPI(url, requestBody, result.data.IdentityToken);
            }
        })
    }
}

async function putDataAPI(url, requestBody, token) {
    try {
        setApiErrorInfo(false,'')
        config.headers.Authorization = `Bearer ${token}`;
        return await axios.put(apiDetails.HOST_NAME + apiDetails.CONTEXT + url, requestBody, config);  
    } catch (error) {
        let errorResponse = error && error.response && error.response.data;
        if (errorResponse && errorResponse.message) {
            setApiErrorInfo(true,errorResponse.message)
        }
    }
}

async function putData(url, requestBody) {
    let token = isTokenAvailable();
    if (token !== null && token !== "") {
        return await putDataAPI(url, requestBody, token);
    } else {
        return getAuthToken(apiDetails.GENERATE_TOKEN).then(async(result) => {
            if (result.data && result.data.IdentityToken) {
                setAuthToken(result.data);
                return await putDataAPI(url, requestBody, result.data.IdentityToken);
            }
        })
    }  
}

async function deleteDataAPI(url, token) {
    try {
        setApiErrorInfo(false,'')
        config.headers.Authorization = `Bearer ${token}`;
        return await axios.delete(apiDetails.HOST_NAME + apiDetails.CONTEXT + url,  config); 
    } catch (error) {
        let errorResponse = error && error.response && error.response.data;
        if (errorResponse && errorResponse.message) {
            setApiErrorInfo(true,errorResponse.message)
        }
    }
}

async function deleteData(url) {
    let token = isTokenAvailable();
    if (token !== null && token !== "") {
        return await deleteDataAPI(url, token);
    } else {
        return getAuthToken(apiDetails.GENERATE_TOKEN).then(async(result) => {
            if (result.data && result.data.IdentityToken) {
                setAuthToken(result.data);
                return await deleteDataAPI(url, result.data.IdentityToken);
            }
        })
    }  
}

const MODULE = {
    getAuthToken,
    getData,
    postData,
    putData,
    deleteData,
    removeAuthData,
    setAuthToken
}
export default MODULE;